<template>
  <div class="mdc-layout-grid__inner">
    <div class="mdc-layout-grid__cell">
      <post></post>
    </div>
  </div>
</template>

<script>
  import Post from './Post'

  export default {
    components: {
      Post
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Blog.vue?1eb50642